<template>
  <div>
    <h5>
      <p class="ml-5 mt-3">Export Data</p>
    </h5>
    <CRow>
      <CCol col="6">
        <CCard class="ml-5">
          <CCardBody>
            <CInput
              label="Start Date"
              class="mb-0"
              type="date"
              @input="handleStartDate"
              horizontal
            />
          </CCardBody>
        </CCard>
      </CCol>
      <CCol col="6">
        <CCard class="mr-5">
          <CCardBody>
            <CInput
              label="End Date"
              class="mb-0"
              type="date"
              @input="handleEndDate"
              horizontal
            />
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="form-group mr-4">
      <CCol col="12 ">
        <CButton color="primary" class="float-right" @click="handleExportData"
          >Export</CButton
        >
      </CCol>
    </CRow>
  </div>
</template>

<script>
import FileDownload from 'js-file-download'
import jwt from "jsonwebtoken";
import ReportUseCase from "../app/usecase/index.js";
import ACCOUNT_GROUP from "../../../../../app/enum/groups.js";

export default {
  name: "Performance",
  data() {
    return {
      request : {
        start_date: "",
        end_date: "",
      },
      url: "",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
  },

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === ACCOUNT_GROUP.NPOS ||
        data.account_group === ACCOUNT_GROUP.ADMIN ||
        data.account_group === ACCOUNT_GROUP.ADMINISTRATOR
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    handleStartDate(event) {
      this.request.start_date = event;
    },
    handleEndDate(event) {
      this.request.end_date = event;
    },
    async handleExportData() {
        var queryString = Object.keys(this.request)
          .map((key) => key + "=" + this.request[key])
          .join("&");       
        const { data, err } = await ReportUseCase.exportReport(queryString);
        if (data) {
             FileDownload(data, "report_agent_" + this.request.start_date + "-" + this.request.end_date + ".csv")
        }else {
           if (err) {
             await this.$swal.fire({
                  icon: "error",
                  text: err,
              });
           }
        }
    },
  },
};
</script>
